import React, { useEffect, useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useCollect } from 'hooks';

import Show from 'components/Show';
import Progress from 'components/Misc/Progress';
import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';

import Courses from 'containers/Student/Subjects/Profile/Courses';

import { useAppStore } from 'store/useAppStore';

const Profile = () => {
	// Cache current object's id
	const { id } = useParams();

	// Use app's store
	const setTitle = useAppStore(state => state.setTitle);

	// Store requested subject
	const [[subject, progress], collect] = useCollect(`subjects/${id}`);

	// Set page's title
	useEffect(() => setTitle(subject?.title), [subject]);

	// Collect subject on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	return (
		<div className="space-y-4 mx-auto max-w-screen-md">
			<Container className="mx-auto max-w-screen-md p-4 space-y-4">
				{/* Show progress */}
				<Progress progress={progress} />

				{/* Show subject collected */}
				<Show if={!progress && subject?.id}>
					<Title
						title={subject?.title}
						className="flex-1 text-xl"
					/>
				</Show>
			</Container>

			{/* Student course's materials */}
			<Courses />
		</div>
	);
};

export default Profile;